var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "-909 226 100 100",
    style: {
      enableBackground: "new -909 226 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-815.3,294.5v-25.9l2.3-1.2c1.4-0.6,2.2-2.3,2.2-3.6c0-1.2-0.6-2.3-1.8-3.3l-0.2-0.2l-44.8-22.5c-1.2-0.6-2.4-0.6-3.6,0 l-45.1,22.5l-0.3,0.3c-0.8,0.8-1.3,1.9-1.3,3.1c0,1.2,0.6,2.8,2.2,3.6l14.8,7.3V294c0,11.5,14,20.5,31.8,20.5c8,0,15.7-1.9,21.6-5.5 c6.6-3.8,10.2-9.2,10.2-15.3v-19l7.1-3.6v23.4l-4.4,4.4c-1,1-1,2.6,0,3.5l5.2,5.2c1,1,2.6,1,3.5,0l5.1-5.2c1-1,1-2.6,0-3.5 L-815.3,294.5z M-859.4,242.6l42.4,21.3l-41.8,21.3l-43-21.4L-859.4,242.6z M-832.4,293.7c0,4.2-2.7,8.2-7.7,11l0,0 c-5.1,3.1-11.9,4.8-19.1,4.8c-14.8,0-26.8-6.9-26.8-15.5v-15.9l26.2,13c0.7,0.4,1.6,0.3,2.3,0l25.1-13.1V293.7z M-817.8,302.3 l-1.6-1.6l1.6-1.6l1.6,1.6L-817.8,302.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.f4b6bab15d18025c1716ab0b19a6ec55.svg";
export { ForwardRef as ReactComponent };